var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseTeaser',{attrs:{"force-ratio":true,"headline":_vm.service.headline,"image":_vm.service.image,"link":_vm.link,"text":_vm.service.text,"aspect-ratio":"16:9","media-type":"image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }